// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"db674917","455":"54092f1f","977":"87f17575"}[chunkId] + ".chunk.js";
};